//
//
//
//
//
//
//
//
//
//
//
//

import Chart from "chart.js";

export default {
  name: "Pie",
  props: {
    height: {
      type: Number,
      default: 200
    },

    kind: {
      type: String,
      default: "pie"
    },

    legend: {
      type: Boolean,
      default: true
    },

    dataPoints: {
      type: Array,
      default: () => []
    },

    labels: {
      type: Array,
      default: () => []
    },

    textContent: {
      type: String,
      default: ""
    },

    colors: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    chart: {}
  }),

  watch: {
    dataPoints(newVal) {
      if (newVal) {
        this.createChart();
      }
    }
  },

  mounted() {
    this.createChart();
  },

  methods: {
    createChart() {
      if (this.chart &&
          Object.keys(this.chart).length !== 0) {
        this.chart.destroy();
      }

      const data = {
        labels: this.labels,
        datasets: [{
          data: this.dataPoints,
          backgroundColor: this.colors,
        }]
      };

      this.chart = new Chart(this.$refs.chart, {
        type: this.kind,
        data: data,
        options: {
          legend: this.legend ? {
            display: true,
            position: 'bottom'
          } : false,
          maintainAspectRatio: false,
          elements: {
            center: {
              text: this.textContent
            }
          }
        }
      });
    }
  }
}
